import _factory from './_factory';
import datetime from '../../utils/datetime';
import collectionServiceFactory from '../../services/collectionServiceFactory';

const moviesService = collectionServiceFactory('movies');

export default {
  ..._factory('movies', {
    state: {
      page: null,
      limit: null,
      loadingMoviesDirection: {
        next: true,
        prev: true,
      },
      selectedDate: new Date(),
    },

    actions: {
      async initLoadMoviesOfMonthForDate({
        commit, state: {
          page, limit, filter,
        },
      }, date) {
        commit('setLoading', true);

        const { dateStart: dateStartGte, dateEnd: dateStartLt } = datetime.getMonthByDate(date, 2);

        const [, data] = await moviesService.fetchItems({
          page, limit, filter: { ...filter, dateStartGte, dateStartLt },
        });

        if (data) {
          const { items } = data;

          commit('setFilterValue', { field: 'dateStartGte', value: dateStartGte });
          commit('setFilterValue', { field: 'dateStartLt', value: dateStartLt });
          commit('setItems', { items });
          commit('changeSelectedDate', date);
        }

        commit('setLoading', false);
      },

      async loadMoviesOfNextMonthForDate({
        commit, state: {
          page, limit, filter, loadingMoviesDirection,
        },
      }, date) {
        if (!loadingMoviesDirection.next) return;

        commit('setLoading', true);

        const dateStartLt = datetime.convertDateToDbFormat(datetime.findMonthEnd(date));
        const dateStartGte = datetime.convertDateToDbFormat(datetime.findMonthStart(date));

        const [, data] = await moviesService.fetchItems({
          page, limit, filter: { ...filter, dateStartLt, dateStartGte },
        });

        if (data) {
          const { items } = data;

          if (items.length) {
            commit('pushItems', { items });
            commit('setFilterValue', { field: 'dateStartLt', value: dateStartLt });
            commit('changeSelectedDate', date);
          } else {
            commit('setLoadingMoviesDirection', { type: 'next', value: false });
          }
        }

        commit('setLoading', false);
      },

      async loadMoviesOfPrevMonthForDate({
        commit, state: {
          page, limit, filter, loadingMoviesDirection,
        },
      }, date) {
        if (!loadingMoviesDirection.prev) return;

        commit('setLoading', true);

        const dateStartLt = datetime.convertDateToDbFormat(datetime.findMonthEnd(date));
        const dateStartGte = datetime.convertDateToDbFormat(datetime.findMonthStart(date));

        const [, data] = await moviesService.fetchItems({
          page, limit, filter: { ...filter, dateStartGte, dateStartLt },
        });

        if (data) {
          const { items } = data;

          if (items.length) {
            commit('prependItems', { items });
            commit('setFilterValue', { field: 'dateStartGte', value: dateStartGte });
            commit('changeSelectedDate', date);
          } else {
            commit('setLoadingMoviesDirection', { type: 'prev', value: false });
          }
        }

        commit('setLoading', false);
      },

      changeFilterMovies({ commit, dispatch }, { field, value }) {
        commit('setLoadingMoviesDirection', { type: 'prev', value: true });
        commit('setLoadingMoviesDirection', { type: 'next', value: true });
        dispatch('changeFilter', { field, value });
      },

      async patchItem({ commit }, { item }) {
        if (!item) {
          return;
        }

        commit('patchItem', item);
      },
    },

    mutations: {
      prependItems(state, { items }) {
        state.items = [...items, ...state.items];
      },

      changeSelectedDate(state, date) {
        state.selectedDate = date;
      },

      setLoadingMoviesDirection(state, { type, value }) {
        state.loadingMoviesDirection[type] = value;
      },

      patchItem(state, item) {
        const items = state.items.slice();
        const index = items.findIndex((value) => value.id === item.id);
        if (index === -1) {
          return;
        }
        items[index] = item;
        state.items = [...items];
      },
    },
  }),
};
